import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Input from "../../coraWebComponents/forms/Input";
import Tooltip from "../../coraWebComponents/forms/Tooltip";

// actions
import * as mapaActions from "../../actions/mapaActions";
import * as ziadostActions from "../../actions/ziadostActions";

class OblastZaujmu extends React.Component {

  saveData = async () => {
    const { ulozData, getMapaExtentCoords, getMapaImage } =
      this.props;

    await getMapaImage();
    await getMapaExtentCoords();

    const { coords, image } = this.props;
    if (coords && image) ulozData({ OblastZaujmu: { coords, image } });
  };

  componentDidMount = async () => {
    this.props.setRef(this);
  };

  render() {
    const {
      className,
      isLoading,
      url,
      cancel,
      moveNext,
      moveBack,
      onKeyDown,
      ziadost,
      index,
    } = this.props;

    const { DetailStavby } = ziadost;

    let adresa = "adresa";
    if (DetailStavby?.AdresaStavby) {
      const { ULICA, OBEC, PSC, CS, CO } = DetailStavby.AdresaStavby;

      // HANDLE ADRESA FORMAT - ULICA CS/CO, PSC OBEC
      adresa = `${ULICA ? ULICA + " " : ""}`;
      if (CS !== null && CO !== "") adresa += `${CS}/${CO}, `;
      else if (CS !== null || CO !== "") adresa += `${CS || CO}, `;
      adresa += `${PSC ? PSC + " " : ""}`;
      adresa += `${OBEC}`;
    }

    return (
      <div className={`row m-0 ${className}`}>
        <div className="col-8 offset-2 p-0 forWeb">
          <div className="card formular">
            <div className="form-body">
              <Tooltip>
                {/* FORM */}
                <form
                  id={`webForm${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  <div className="card-title">
                    <div>Oblasť záujmu</div>
                  </div>
                  <p>&nbsp;</p>
                  {/* ADRESA */}
                  <div className="k-form-field">
                    <span>{"Adresa"}</span>
                    <Input
                      title={"Adresa"}
                      type="text"
                      name="adresa"
                      onChange={() => { }}
                      value={adresa}
                      disabled
                    />
                  </div>
                  {/* MAPA */}
                  <div className="k-form-field">
                    <iframe
                      id="map_iframe"
                      title="Mapa - nastavte výrez (zoom), alebo zakreslite polygón.  V prípade, ak nie je zadaný polygón, vytvorí sa automaticky podľa rozmeru mapového okna."
                      src={url}
                    />
                  </div>

                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button primary label="Zrusiť" onClick={cancel} />
                    <div className="flexGroup">
                      <Button primary label="Späť" onClick={moveBack} />
                      <Button type="submit" label="Ďalej" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mapa.isLoading,
  url: state.mapa.url,
  coords: state.mapa.coords,
  extent: state.mapa.extent,
  image: state.mapa.image,
});

const mapDispatchToProps = (dispatch) => ({
  ulozData: (data) => dispatch(ziadostActions.ulozData(data)),
  getMapaImage: () => dispatch(mapaActions.getMapaImage()),
  getMapaExtentCoords: () => dispatch(mapaActions.getMapaExtentCoords()),
});

OblastZaujmu.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  ziadost: PropTypes.object,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  url: PropTypes.string,
  ulozData: PropTypes.func,
  getMapaExtentCoords: PropTypes.func,
  getMapaImage: PropTypes.func,
  changeExtentCoords: PropTypes.func,
  changeImage: PropTypes.func,
  coords: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(OblastZaujmu);
